import { memo, useState } from "react"

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@productlane/ui"

import type { ReportingQueryProps } from "../reporting-query"
import { IssuesVisualization } from "@/components/issues-visualization"
import { ProjectsVisualization } from "@/components/projects-visualization"
import { reportingCardClassName } from "@/components/reporting/charts"
import { TagsVisualization } from "@/components/tags-visualization"

export const FeedbackTab = memo((props: ReportingQueryProps) => {
	const { startDate, endDate, ...filters } = props
	const [section, setSection] = useState("projects")

	return (
		<div className="space-y-4 p-4 pb-2 sm:p-6">
			<Tabs value={section} onValueChange={setSection}>
				<TabsList>
					<TabsTrigger value="projects">Projects</TabsTrigger>
					<TabsTrigger value="issues">Issues</TabsTrigger>
					<TabsTrigger value="tags">Tags</TabsTrigger>
				</TabsList>
				<TabsContent value="projects" className="mt-4">
					<div className={`${reportingCardClassName} overflow-hidden p-4`}>
						<ProjectsVisualization
							startDate={startDate}
							endDate={endDate}
							{...filters}
						/>
					</div>
				</TabsContent>
				<TabsContent value="issues" className="mt-4">
					<div className={`${reportingCardClassName} overflow-hidden p-4`}>
						<IssuesVisualization
							startDate={startDate}
							endDate={endDate}
							{...filters}
						/>
					</div>
				</TabsContent>
				<TabsContent value="tags" className="mt-4">
					<div className={`${reportingCardClassName} overflow-hidden p-4`}>
						<TagsVisualization
							startDate={startDate}
							endDate={endDate}
							{...filters}
						/>
					</div>
				</TabsContent>
			</Tabs>
		</div>
	)
})
